
import React, { useEffect, useState } from 'react';
import { Button, Card, Table, Modal, Form } from 'react-bootstrap';
import { BsChevronDown, BsChevronRight, BsPencil } from 'react-icons/bs';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import CatPermisos from '../../../Services/Catalogos/CatPermisos';
import { DTOPermiso } from '../CatPermisos/DTO/DTOPermiso';
import DTOEmpleadoVac from '../../Catalogos/CatEmpleados/DTO/DTOEmpleadoVac';
import './ControlPermisos.css';

import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';

const ControlPermisos = () => {
  const [empleados, setEmpleados] = useState<DTOEmpleadoVac[]>([]);
  const [permisosPorEmpleado, setPermisosPorEmpleado] = useState<Record<string, DTOPermiso[]>>({});
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const [showModal, setShowModal] = useState(false);
  const [permisoEditando, setPermisoEditando] = useState<DTOPermiso | null>(null);
  const [cargando, setCargando] = useState(false);
  const [msg, setMsg] = useState('');
const [header, setHeader] = useState('');
const [showMsg, setShowMsg] = useState(false);
const msgColor = 'success'; // o 'danger', 'primary', según el uso


const [currentPage, setCurrentPage] = useState(1);
const empleadosPerPage = 5;
const indexOfLastEmpleado = currentPage * empleadosPerPage;
const indexOfFirstEmpleado = indexOfLastEmpleado - empleadosPerPage;
const currentEmpleados = empleados.slice(indexOfFirstEmpleado, indexOfLastEmpleado);
const totalPages = Math.ceil(empleados.length / empleadosPerPage);


  useEffect(() => {
    const idUsuario = localStorage.getItem('UserId')?.replace(/"/g, '');
    if (idUsuario) {
      cargarEmpleados(idUsuario);
    }
  }, []);

  useEffect(() => {
  const interval = setInterval(() => {
    empleados.forEach((emp) => {
      cargarPermisos(emp.numEmpleado); 
    });
  }, 10000); 

  return () => clearInterval(interval);
}, [empleados]);


  const cargarEmpleados = async (idSupervisor: string) => {
    setCargando(true);
    try {
      const empleadosData = await CatEmpleados.GetIdSupervisor(idSupervisor);
      setEmpleados(empleadosData.data);
      empleadosData.data.forEach((emp: DTOEmpleadoVac) => cargarPermisos(emp.numEmpleado));
    } catch (error) {
      console.error('Error al cargar empleados:', error);
    } finally {
      setCargando(false);
    }
  };

  const cargarPermisos = async (numEmpleado: string) => {
    try {
      const res = await CatPermisos.GetPermisosPorEmpleado(numEmpleado);
      setPermisosPorEmpleado(prev => ({ ...prev, [numEmpleado]: res.data || [] }));
    } catch (err) {
      console.error('Error al cargar permisos:', err);
    }
  };

  const toggleRow = (numEmpleado: string) => {
    setExpandedRows(prev => ({ ...prev, [numEmpleado]: !prev[numEmpleado] }));
  };

  const handleEditPermiso = (permiso: DTOPermiso) => {
    setPermisoEditando(permiso);
    setShowModal(true);
  };



const guardarEstadoPermiso = async () => {
  if (!permisoEditando) return;

  try {
    if (permisoEditando.estado === 'Rechazado') {
      const deleteRes = await CatPermisos.DeletePermiso(permisoEditando.id);

      setPermisosPorEmpleado(prev => ({
        ...prev,
        [permisoEditando.numEmpleado]: prev[permisoEditando.numEmpleado]?.filter(p => p.id !== permisoEditando.id) || []
      }));

      if (permisoEditando.correo) {
        try {
          await CatPermisos.EnviarCorreoPermiso({
            id: permisoEditando.id,
            numEmpleado: permisoEditando.numEmpleado,
            nombreEmpleado: permisoEditando.nombreEmpleado || '',
            correo: permisoEditando.correo,
            motivo: permisoEditando.motivo || '',
            fechaPermiso: permisoEditando.fechaPermiso || '',
            estado: 'Rechazado',
            observaciones: permisoEditando.observaciones || '',
          });
        } catch (error) {
          console.error('Error al enviar correo:', error);
        }
      }

      setHeader('Permiso Rechazado');
      setMsg(deleteRes.data?.Message || 'Permiso eliminado correctamente');
      setShowMsg(true);

    } else {
      await CatPermisos.PutEstadoPermiso(
        permisoEditando.id,
        permisoEditando.estado,
        permisoEditando.permisoConSueldo ?? false,
        // permisoEditando.observaciones || ''
        permisoEditando.observaciones?.trim() === '' ? 'Sin observaciones' : permisoEditando.observaciones

      );

      // ✅ Enviar correos si fue ACEPTADO
      if (permisoEditando.estado === 'Aceptado' && permisoEditando.correo) {
        try {
          
          await CatPermisos.EnviarCorreoPermiso({
            id: permisoEditando.id,
            numEmpleado: permisoEditando.numEmpleado,
            nombreEmpleado: permisoEditando.nombreEmpleado || '',
            correo: permisoEditando.correo,
            motivo: permisoEditando.motivo || '',
            fechaPermiso: permisoEditando.fechaPermiso || '',
            estado: 'Aceptado',
            // observaciones: permisoEditando.observaciones || '',
             observaciones: permisoEditando.observaciones?.trim() === '' ? 'Sin observaciones' : permisoEditando.observaciones
          });

         
          await CatPermisos.EnviarCorreoRH(permisoEditando);

        } catch (error) {
          console.error('Error al enviar correos:', error);
        }
      }

      await cargarPermisos(permisoEditando.numEmpleado);

      setHeader('Estado actualizado');
      setMsg('El estado del permiso fue actualizado correctamente.');
      setShowMsg(true);
    }

    setShowModal(false);
  } catch (error) {
    console.error('Error al actualizar permiso:', error);
    setHeader('Error');
    setMsg('Ocurrió un error al guardar los cambios.');
    setShowMsg(true);
  }
};



const calcularEstadoPredominante = (numEmpleado: string) => {
  const permisos = permisosPorEmpleado[numEmpleado];
  if (!permisos || permisos.length === 0) return 'Sin permisos';

  if (permisos.some(p => p.estado === 'Pendiente')) return 'Pendiente';
  if (permisos.every(p => p.estado === 'Aceptado')) return 'Aceptado';

  return 'Otros';
};


const getRowClass = (estado: string) => {
  switch (estado) {
    case 'Pendiente': return 'fila-pendiente';
    case 'Rechazado': return 'fila-rechazado';
    case 'Aceptado': return 'fila-aceptado';
    default: return '';
  }
};



const styles = `
  .fila-pendiente td {
    background-color: #ffcc99 !important;
  }

  .fila-rechazado td {
    background-color: #f8d7da !important;
  }

  .fila-aceptado td {
    background-color: #d4edda !important;
  }

  .encabezado-pendiente td {
    background-color: #ffcc99 !important;
    font-weight: bold;
  }

  .encabezado-normal td {
    background-color: white !important;
  }
`;


useEffect(() => {
  const styleElement = document.createElement('style');
  styleElement.innerText = styles;
  document.head.appendChild(styleElement);
}, []);


  
  return (
    
    <Card className="control-permisos-container shadow-sm">
      <Card.Body>
        {/* <h4>Control de Permisos</h4> */}
        
        {/* <Table striped bordered hover> */}
        <Table className="control-permisos-table" striped bordered hover>

          <thead>
            <tr>
              <th></th>
              <th>Número</th>
              <th>Nombre</th>
              <th>Departamento</th>
              <th>Supervisor</th>
            </tr>
          </thead>
          <tbody>
            {currentEmpleados.map((empleado) => (

              <React.Fragment key={empleado.numEmpleado}>
                <tr className={calcularEstadoPredominante(empleado.numEmpleado) === 'Pendiente' ? 'encabezado-pendiente' : 'encabezado-normal'}>

                  <td onClick={() => toggleRow(empleado.numEmpleado)} style={{ cursor: 'pointer' }}>
                    {expandedRows[empleado.numEmpleado] ? <BsChevronDown /> : <BsChevronRight />}
                  </td>
                  <td>{empleado.numEmpleado}</td>
                  <td>{empleado.nombreEmpleado}</td>
                  <td>{empleado.departamento}</td>
                  <td>{empleado.nombreSupervisor}</td>
                </tr>
                {expandedRows[empleado.numEmpleado] && (
                  <tr>
                    <td colSpan={5}>
                      {/* <Table bordered size="sm"> */}
                        <Table bordered size="sm" className="subtabla">
                        <thead>
                          <tr>
                            <th>FechaPermiso</th>
                            <th>Motivo</th>
                            <th>Horario</th>
                            <th>Estado</th>
                            <th>MisObservaciones</th>
                            <th>Con Sueldo</th>
                            <th>Acciones</th>
                          </tr>c
                        </thead>
                        <tbody>
                          {(permisosPorEmpleado[empleado.numEmpleado] || []).map((permiso) => (
                            <tr key={permiso.id} className={getRowClass(permiso.estado)}>

                              <td>{permiso.fechaPermiso}</td>
                              <td>{permiso.motivo}</td>
                              <td>{permiso.esDiaCompleto ? 'Día completo' : `${permiso.horaInicio} - ${permiso.horaFin}`}</td>
                              <td>{permiso.estado}</td>
                              <td>{permiso.observaciones}</td>
                              <td>{permiso.permisoConSueldo ? 'Sí' : 'No'}</td>
                              <td>
                                <BsPencil style={{ cursor: 'pointer' }} onClick={() => handleEditPermiso(permiso)} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Permiso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Estado</Form.Label>
              <Form.Select
                value={permisoEditando?.estado || ''}
                onChange={(e) =>
                  setPermisoEditando(prev => prev ? { ...prev, estado: e.target.value } : null)
                }
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Aceptado">Aceptado</option>
                <option value="Rechazado">Rechazado</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Goce de Sueldo</Form.Label>
              <Form.Check
                type="checkbox"
                checked={permisoEditando?.permisoConSueldo || false}
                onChange={(e) =>
                  setPermisoEditando(prev => prev ? { ...prev, permisoConSueldo: e.target.checked } : null)
                }
                label="¿Con goce de sueldo?"
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={permisoEditando?.observaciones || ''}
                onChange={(e) =>
                  setPermisoEditando(prev => prev ? { ...prev, observaciones: e.target.value } : null)
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={guardarEstadoPermiso}>Guardar</Button>
        </Modal.Footer>
      </Modal>


 {totalPages > 1 && (
  <div className="d-flex justify-content-center my-3">
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className="mx-1"
    >
      Anterior
    </Button>
    <span className="align-self-center mx-2">
      Página {currentPage} de {totalPages}
    </span>
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className="mx-1"
    >
      Siguiente
    </Button>
  </div>
)}

      <MsgInformativo
  show={showMsg}
  msg={msg}
  header={header}
  msgColor={msgColor}
  closeToast={() => setShowMsg(false)}
/>

    </Card>

    
  );

  
};

export default ControlPermisos;